/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ValidationRequirementStatusChangedBy;

(function (ValidationRequirementStatusChangedBy) {
  ValidationRequirementStatusChangedBy["SYSTEM"] = "system";
  ValidationRequirementStatusChangedBy["AGENT"] = "agent";
})(ValidationRequirementStatusChangedBy || (ValidationRequirementStatusChangedBy = {}));